import React from "react";
import Header from "../Home/header";
import Footer from "../Home/footer";


function DC() { 
    return (
        <>
            <Header />
            <h1>DC</h1>
            <Footer />
        </>
    )
}

export default DC;